import { getRequestedTabFromUrl } from '../../utils/tab-helpers';
import { get, getTrackingString, isProfilePage, isProfilePageEdit } from '../../utils/object-helpers';
import storeEvent from '../../utils/store-event';

const KEY = 'str-seller-card';
const SEL = {
    feedbackLink: '.str-seller-card__feedback-link'
};

export default class {
    onCreate() {
        this.state = {
            dirtyState: false,
            showConfirmDialog: false
        };
    }
    onInput(input) {
        const info = get(input, 'page.modules.PRESENCE_INFORMATION_MODULE', null);
        const followTextSpans = get(info, 'followerDescription.textSpans', []);
        const feedbackTextSpans = get(info, 'feedbackDescription.textSpans', []);
        const soldTextSpans = get(info, 'soldDescription.textSpans', []);
        const contactSellerText = get(input, 'page.modules.CONTACT_SELLER_MODULE.contactAction.text', '');
        const contactSellerLink = get(input, 'page.modules.CONTACT_SELLER_MODULE.contactAction.action.URL', '');
        let contactSeller;
        if (contactSellerText && contactSellerLink) {
            contactSeller = {
                text: contactSellerText,
                link: contactSellerLink
            };
        }

        const dialogInfo = get(input, 'page.modules.ACCOUNT_SETTINGS_DIRTY_STATE_MODULE', null);
        const confirmationModalTitleTextSpans = get(dialogInfo, 'title.textSpans', []);
        const confirmationModalSubTitleTextSpans = get(dialogInfo, 'subTitle.textSpans', []);
        const saveAndGoAction = get(dialogInfo, 'saveAndGoAction', null);
        const dismissAndGoAction = get(dialogInfo, 'dismissAndGoAction', null);
        const saveActionText = get(saveAndGoAction, 'text', '');
        const saveActionURL = get(saveAndGoAction, 'action.URL', '');
        const dismissActionText = get(dismissAndGoAction, 'text', '');
        const dismissActionURL = get(dismissAndGoAction, 'action.URL', '');

        return {
            headerLogoInput: {
                ...info,
                globalState: input.globalState
            },
            name: {
                text: get(info, 'displayName.textSpans', []),
                link: get(info, 'displayName.action.URL', ''),
                tracking: getTrackingString(info, 'displayName.action.trackingList')
            },
            logo: {
                title: get(info, 'logo.title', ''),
                imageUrl: get(info, 'logo.URL', ''),
                link: get(info, 'logo.action.URL', ''),
                a11y: get(info, 'logo.title', ''),
                tracking: getTrackingString(info, 'logo.action.trackingList')
            },
            editProfileDescriptions: {
                editProfileDescriptionsLine1: get(info, 'editProfileDescriptions.0.textSpans.0.text', ''),
                editProfileDescriptionsLine2: get(info, 'editProfileDescriptions.1.textSpans.0.text', ''),
                profilePageURL: get(info, 'editProfileDescriptions.1.action.URL', ''),
                tracking: getTrackingString(info, 'editProfileDescriptions.1.action.trackingList')
            },
            follow: {
                textSpans: followTextSpans,
                textString: getString(followTextSpans)
            },
            feedback: {
                textSpans: feedbackTextSpans,
                textString: getString(feedbackTextSpans),
                link: get(info, 'feedbackDescription.action.URL', ''),
                tracking: getTrackingString(info, 'feedbackDescription.action.trackingList')
            },
            confirmationModal: {
                title: getString(confirmationModalTitleTextSpans),
                subTitle: getString(confirmationModalSubTitleTextSpans),
                saveAndGoAction,
                saveAction: {
                    text: saveActionText,
                    url: saveActionURL
                },
                dismissAndGoAction,
                dismissAction: {
                    text: dismissActionText,
                    url: dismissActionURL
                }
            },
            sold: {
                textSpans: soldTextSpans,
                textString: getString(soldTextSpans)
            },
            isProfilePage: isProfilePage(input.page),
            isProfilePageEdit: isProfilePageEdit(input.page),
            globalState: input.globalState,
            contactSeller: contactSeller,
            page: input.page
        };
    }
    onMount() {
        this.root = this.getEl(KEY);
        if (this.root) {
            const feedbackLink = this.root.querySelector(SEL.feedbackLink);
            if (feedbackLink) {
                feedbackLink.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    const href = evt.target.getAttribute('href');
                    if (href) {
                        storeEvent.changeToTab.dispatch({
                            tabIndex: getRequestedTabFromUrl(href),
                            skipFocus: true
                        });
                    }
                });
            }
        }
        storeEvent.presenceEdit.listen(data => {
            if (data) {
                if (data.dirtyState) {
                    this.state.dirtyState = true;
                } else if (data.action) {
                    if (data.action.name === 'SAVE_EBAY_USER_PROFILE'
                        || data.action.name === 'CANCEL_EDIT_EBAY_USER_PROFILE') {
                        this.state.dirtyState = false;
                    }
                }
            }
        });
    }
    openDialog(saveActionURL) {
        this.state.showConfirmDialog = this.state.dirtyState;
        if (!this.state.dirtyState) {
            window.location.href = saveActionURL;
        }
    }

    saveAndNavigate(action, saveActionURL) {
        storeEvent.presenceEdit.dispatch({ action });
        this.emit('confirm', {
            tracking: action
        });
        this.state.dirtyState = false;
        window.location.href = saveActionURL;
    }

    navigateWithoutSaving(action, dismissActionURL) {
        this.state.showConfirmDialog = false;
        this.state.dirtyState = false;
        this.emit('reject', {
            tracking: action
        });
        window.location.href = dismissActionURL;
    }
}

function getString(textSpans) {
    if (textSpans && textSpans.length) {
        const text = [];
        for (const span of textSpans) {
            text.push(span.text);
        }
        return text.join(' ').trim();
    }
    return '';
}
